var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mb-2", on: { click: _vm.onClick } },
    [
      _vm.component
        ? _c(_vm.component, {
            tag: "component",
            attrs: { item: _vm.item, "is-current": _vm.isCurrent },
            on: {
              "show-messages": (e) => _vm.$emit("show-messages", e),
              "refresh-list": () => _vm.$emit("refresh-list"),
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }